export default ".ng-invalid+.invalid-feedback{display:block}.invalid-feedback{color:#b91400;padding-left:10px}";